<template>
  <div class="pwave-docs-header">
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <h1>Peoplewave UI Style Guide</h1>
        </div>
        <div class="col-md-6">
          <img src="https://peoplewave.co/wp-content/uploads/2017/08/Logo-2CRev-80.png" alt="peoplewave" class="img-responsive pwave-logo">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/assets/components/PwHeader.vue